import { LightningElement, api } from 'lwc';
import { getLabelsByLanguage, TEMPLATE_LABELS, mapTemplateLabels } from '../../../utils/languageUtil';



function handleIcon(icon) {
    if (!icon) return;
    const parts = icon?.split(':');
    if (parts?.length !== 2) return;
    const [category, name] = parts;

    const container = `slds-icon_container slds-icon-${category}-${name}`;
    const iconRef = `static/assets/icons/${category}-sprite/svg/symbols.svg#${name}`;
    return {
        container,
        icon: iconRef
    };
}

function getIdxFromEvt(evt) {
    const cIdx = Number(evt?.currentTarget?.dataset?.index);
    const tIdx = Number(evt?.dataset?.target?.index);

    return isNaN(cIdx) ? tIdx : cIdx;

}
let KEY_ID = 92378;

const MULTI_EDIT_CL = 'slds-grid slds-grid_pull-padded-medium slds-m-top_xx-small';
const SINGLE_EDIT_CL = 'slds-grid slds-grid_pull-padded-medium slds-m-top_xx-small';



function formatAddress(addressValueArr) {
    const street = addressValueArr.find(f => f.fieldApiName === 'street')?.value ?? '';
    const city = addressValueArr.find(f => f.fieldApiName === 'city')?.value ?? '';
    const state = addressValueArr.find(f => f.fieldApiName === 'state')?.value ?? '';
    const zip = addressValueArr.find(f => f.fieldApiName === 'zip_code')?.value ?? '';

    if ([street, city, state, zip].every(v => !v)) {
        return '';
    }

    return `${street}, ${city}, ${state} ${zip}`;
}

export default class gwDetailPicker extends LightningElement {
    templateLabels = mapTemplateLabels(TEMPLATE_LABELS);

    formInputHeight = '2.00rem';
    formInputBorderRadius='var(--slds-g-radius-border-3, 0.75rem)';

    @api isModal = false;
    
    // Turns button into a form when clicked 
    @api 
    set isForm(val) {
        this._isForm = val;
    }
    get isForm() {
        return !!this._isForm;
    }

    /* structure: [ 
          {icon: 'standard:email', isHorizontal=false, label: 'Email', valueArr: [ 
                  {fieldApiName: 'email' value: 'me@example.com', displayValue: 'me@example.com'},
                  {fieldApiName: 'email2' value: 'me2movement@example.com', displayValue: 'me2movement@example.com'},
              ]
          },
          {icon: 'standard:account', label: 'Name', isHorizontal=true, valueArr: [
                      {fieldApiName: 'firstName', value: 'Cory', displayValue: 'Cory'},
                      {fieldApiName: 'LastName', value: 'Rhodes', displayValue: 'Rhodes'},
                  }, 
              ]
    };*/
    _options = [];
    @api  
    set options(val) {
        if (val) {
            this._options = (val ?? []).map((opt, index) => {
                const formattedDisplay = (
                        opt?.isAddress || opt?.label?.toLowerCase().includes('address')
                    ) ? formatAddress(opt?.valueArr ?? [])
                    : null;
                
                //console.log('here is valueArr in gwDetailPicker.js: ', JSON.stringify(opt?.valueArr));
                return {
                    ...opt,
                    label: getLabelsByLanguage(opt.label),
                    keyId: String(KEY_ID++),
                    icon: handleIcon(opt.icon),
                    index,
                    formattedDisplay,
                    editCl: `slds-size_1-of-${opt?.valueArr?.length ?? 1} slds-col slds-p-horizontal_small`,
                    valueArr: (opt?.valueArr ?? []).map( (v, idx) => ({
                        ...v, 
                        label: getLabelsByLanguage(v.label),
                        keyId: String(KEY_ID++), 
                        isFirst: idx === 0, 
                        dtype: v?.dtype ?? 'text',
                        [`is${v?.dtype?.toLowerCase() ?? 'text'}`]: true
                    }))
                }
            })
        }
    }
    get options() {
        return this._options;
    }

    @api 
    set backgroundColor(val) {
        this._backgroundColor = val;
        if (val) {
            this._applyVarsDirect('--gw-bg-detail-picker', val);
        }
    }
    get backgroundColor() {
        return this._backgroundColor;
    }

    @api 
    set border(val) {
        this._border = val;
        if (val) {
            this._applyVarsDirect('--gw-border-detail-picker', val);
        }
    }
    get border() {
        return this._border;
    }

    @api 
    set firstBorderRadius(val) {
        this._firstBorderRadius = val;
        this._applyVarsDirect('--gw-border-radius-detail-picker_first', val)
    }
    get firstBorderRadius() {
        return this._firstBorderRadius;
    }
    @api 
    set lastBorderRadius(val) {
        this._lastBorderRadius = val;
        this._applyVarsDirect('--gw-border-radius-detail-picker_last', val)
    }
    get lastBorderRadius() {
        return this._lastBorderRadius;
    }


    modalEditConfig;

    handleOptionClick(event) {
        event.preventDefault();
        const idx = getIdxFromEvt(event);
        if (this.isForm || this.isModal) {
            // Set the clicked option to editing
            const idxdOpt = (this._options ?? [])?.[idx];
            const keyId = idxdOpt?.keyId ?? 'dummmiekeyid93930202';

            if (idxdOpt.isFile) {
                // ⚠️ WARNING: THIS IS A TEMPORARY IMPLEMENTATION
                this.dispatchEvent(new CustomEvent('fileclick', { detail: '' } ));
                return;
            }
            if (this.isModal) {
                const active = this.template.activeElement;
                const selected = (this._options ?? []).find(opt => opt.keyId === keyId);
                if (selected) {
                    this.modalEditConfig = {
                        option: selected,
                        modalTitle: selected.label,
                        active
                    }
                }
                requestAnimationFrame(() => {
                    const ele = this.template.querySelector('.modal-body x-dropdown-plain, .modal-body x-slds-date-picker, .modal-body x-slds-input');
                    if (ele) {
                        ele.focusMe();
                    }
                })
                return;
            }
            
            this._options = (this._options ?? []).map(opt => ({
                ...opt, 
                editing: opt.keyId === keyId    
            }));
            setTimeout(() => {
                const inp = this.template.querySelector('x-slds-input[data-form="true"]');
                if (inp) inp.focusMe();
            }, 100);
            //console.log('is one of the options "editing"? ', JSON.stringify(this._options.find(o => o?.editing)));
            return;
        }
        const option = (this._options ?? []).find((_, index) => index === idx);
        if (option) {
            this.dispatchEvent(new CustomEvent('click', { detail: option } ));
        }
    }

    
    
    
    // Handle field edits in modal
    handleSave() {
        try {
            const editedFields = {};
            const inputs = this.template.querySelectorAll('[data-modal-form="true"]');
            inputs.forEach(inp => {
                const val = inp?.getValue();
                //console.log('in handleSave() of gwDetailPicker.js, here is val: ', val);
                const fieldApiName = inp?.dataset?.fieldApiName;
                //console.log('in handleSave() of gwDetailPicker.js, here is fieldApiName: ', fieldApiName);
                if (fieldApiName) {
                    const fieldsArr = this.modalEditConfig?.option?.valueArr ?? [];
                    const matchedF = fieldsArr.find(f => f?.fieldApiName === fieldApiName);
                    if (!matchedF || (!matchedF?.value && !val) || matchedF?.value === val) return;
                    editedFields[fieldApiName] = val;
                }
            });
            if (Array.from(Object.keys(editedFields))?.length) {
                this.dispatchEvent(new CustomEvent('fieldsedit', { detail: editedFields } ));
            }

        } catch(error) {
            console.error('Error in handleSave() of gwDetailPicker.js', error);
        } finally {
            this.closeModal();
        }
    }
    closeModal() {
        const prevActive = this.modalEditConfig.active;
        this.modalEditConfig = null;
        if (prevActive) {
            prevActive.focus();
        }

    }

    // Apply Styles to the host 👉 Can pass 1.Array of Arrays   2.Array of Object   3.Strings
    _applyVarsDirect(cssVar, varStyle=null) {
        // Check that CSS var starts with '--' and has a non-null stlye 
        const isValid = (cssVarP, varStyleP) => {
            return typeof cssVarP === 'string' && 
                typeof varStyleP === 'string' &&
                cssVarP?.startsWith('--') && 
                varStyleP;
        }
 

        if (Array.isArray(cssVar)) {
            // Handle Array of vars
            cssVar.forEach(hostVar => {
                if (Array.isArray(hostVar) && isValid(hostVar[0], hostVar[1])) {
                    // Handle Array structure  (CSS var at index 0)
                    this.style.setProperty(hostVar[0], hostVar[1]);
                } else if (typeof hostVar === 'object' && isValid(hostVar.cssVar, hostVar.varStyle)) {
                    // Handle Object structure (cssVar & varStyle keys)
                    this.style.setProperty(hostVar.cssVar, hostVar.varStyle)
                }
            });
        } else if (isValid(cssVar, varStyle)) {
            // Handle string arguments
            this.style.setProperty(cssVar,  varStyle);
        }
    }
}